// Language translations for Nexi AI
const translations = {
  en: {
    // Welcome Modal
    welcomeTitle: "Hi! My name is",
    welcomeName: "Nexi",
    welcomeSubtitle: "Your personal AI assistant",
    welcomeDescription: "I'm here to help you with anything - from answering questions to analyzing documents and images.",
    getStarted: "Let's Get Started!",
    consentText: "I agree to the",
    privacyPolicy: "Privacy Policy",
    and: "and",
    termsOfService: "Terms of Service",
    consentDataText: "I consent to Nexi collecting my name and conversation data to provide personalized AI assistance.",
    enterName: "Enter your name...",
    continue: "Continue",
    skip: "Skip",
    
    // Chat Interface
    messagePlaceholder: "Message Nexi...",
    askAnything: "Ask me anything!",
    upgradeTitle: "Upgrade to Premium",
    upgradeDescription: "Get unlimited questions",
    oneTimePurchase: "One-time purchase",
    freeQuestions: "free questions remaining today",
    
    // Upload Menu
    camera: "Camera",
    takePhoto: "Take a photo",
    photoLibrary: "Photo Library",
    chooseFromGallery: "Choose from gallery",
    document: "Document",
    uploadDocument: "PDF, TXT, DOC, CSV",
    
    // Messages
    download: "Download",
    copy: "Copy",
    copied: "Copied!",
    helpful: "Helpful response",
    notHelpful: "Not helpful",
    
    // Sidebar
    newChat: "New Chat",
    conversations: "Conversations",
    noConversations: "No conversations yet",
    
    // Common
    loading: "Loading...",
    error: "Something went wrong",
    tryAgain: "Try again",
  },
  
  es: {
    // Welcome Modal
    welcomeTitle: "¡Hola! Mi nombre es",
    welcomeName: "Nexi",
    welcomeSubtitle: "Tu asistente personal de IA",
    welcomeDescription: "Estoy aquí para ayudarte con cualquier cosa - desde responder preguntas hasta analizar documentos e imágenes.",
    getStarted: "¡Comenzar!",
    consentText: "Acepto la",
    privacyPolicy: "Política de Privacidad",
    and: "y",
    termsOfService: "Términos de Servicio",
    consentDataText: "Consiento que Nexi recopile mi nombre y datos de conversación para proporcionar asistencia personalizada.",
    enterName: "Ingresa tu nombre...",
    continue: "Continuar",
    skip: "Omitir",
    
    // Chat Interface
    messagePlaceholder: "Mensaje a Nexi...",
    askAnything: "¡Pregúntame lo que quieras!",
    upgradeTitle: "Actualizar a Premium",
    upgradeDescription: "Obtén preguntas ilimitadas",
    oneTimePurchase: "Compra única",
    freeQuestions: "preguntas gratis restantes hoy",
    
    // Upload Menu
    camera: "Cámara",
    takePhoto: "Tomar una foto",
    photoLibrary: "Galería de Fotos",
    chooseFromGallery: "Elegir de la galería",
    document: "Documento",
    uploadDocument: "PDF, TXT, DOC, CSV",
    
    // Messages
    download: "Descargar",
    copy: "Copiar",
    copied: "¡Copiado!",
    helpful: "Respuesta útil",
    notHelpful: "No útil",
    
    // Sidebar
    newChat: "Nuevo Chat",
    conversations: "Conversaciones",
    noConversations: "Sin conversaciones aún",
    
    // Common
    loading: "Cargando...",
    error: "Algo salió mal",
    tryAgain: "Intentar de nuevo",
  },
  
  fr: {
    // Welcome Modal
    welcomeTitle: "Salut! Je m'appelle",
    welcomeName: "Nexi",
    welcomeSubtitle: "Votre assistant IA personnel",
    welcomeDescription: "Je suis là pour vous aider avec tout - des réponses aux questions à l'analyse de documents et d'images.",
    getStarted: "Commencer!",
    consentText: "J'accepte la",
    privacyPolicy: "Politique de Confidentialité",
    and: "et",
    termsOfService: "Conditions d'Utilisation",
    consentDataText: "Je consens à ce que Nexi collecte mon nom et mes données de conversation pour fournir une assistance personnalisée.",
    enterName: "Entrez votre nom...",
    continue: "Continuer",
    skip: "Passer",
    
    // Chat Interface
    messagePlaceholder: "Message à Nexi...",
    askAnything: "Demandez-moi n'importe quoi!",
    upgradeTitle: "Passer à Premium",
    upgradeDescription: "Obtenez des questions illimitées",
    oneTimePurchase: "Achat unique",
    freeQuestions: "questions gratuites restantes aujourd'hui",
    
    // Upload Menu
    camera: "Caméra",
    takePhoto: "Prendre une photo",
    photoLibrary: "Photothèque",
    chooseFromGallery: "Choisir dans la galerie",
    document: "Document",
    uploadDocument: "PDF, TXT, DOC, CSV",
    
    // Messages
    download: "Télécharger",
    copy: "Copier",
    copied: "Copié!",
    helpful: "Réponse utile",
    notHelpful: "Pas utile",
    
    // Sidebar
    newChat: "Nouveau Chat",
    conversations: "Conversations",
    noConversations: "Pas encore de conversations",
    
    // Common
    loading: "Chargement...",
    error: "Une erreur s'est produite",
    tryAgain: "Réessayer",
  },
  
  de: {
    // Welcome Modal
    welcomeTitle: "Hallo! Mein Name ist",
    welcomeName: "Nexi",
    welcomeSubtitle: "Ihr persönlicher KI-Assistent",
    welcomeDescription: "Ich bin hier, um Ihnen bei allem zu helfen - von der Beantwortung von Fragen bis zur Analyse von Dokumenten und Bildern.",
    getStarted: "Los geht's!",
    consentText: "Ich stimme der",
    privacyPolicy: "Datenschutzrichtlinie",
    and: "und",
    termsOfService: "Nutzungsbedingungen",
    consentDataText: "Ich stimme zu, dass Nexi meinen Namen und Gesprächsdaten sammelt, um personalisierte Unterstützung zu bieten.",
    enterName: "Geben Sie Ihren Namen ein...",
    continue: "Weiter",
    skip: "Überspringen",
    
    // Chat Interface
    messagePlaceholder: "Nachricht an Nexi...",
    askAnything: "Fragen Sie mich alles!",
    upgradeTitle: "Auf Premium upgraden",
    upgradeDescription: "Unbegrenzte Fragen erhalten",
    oneTimePurchase: "Einmaliger Kauf",
    freeQuestions: "kostenlose Fragen heute übrig",
    
    // Upload Menu
    camera: "Kamera",
    takePhoto: "Foto aufnehmen",
    photoLibrary: "Fotobibliothek",
    chooseFromGallery: "Aus Galerie wählen",
    document: "Dokument",
    uploadDocument: "PDF, TXT, DOC, CSV",
    
    // Messages
    download: "Herunterladen",
    copy: "Kopieren",
    copied: "Kopiert!",
    helpful: "Hilfreiche Antwort",
    notHelpful: "Nicht hilfreich",
    
    // Sidebar
    newChat: "Neuer Chat",
    conversations: "Gespräche",
    noConversations: "Noch keine Gespräche",
    
    // Common
    loading: "Laden...",
    error: "Etwas ist schief gelaufen",
    tryAgain: "Erneut versuchen",
  },
  
  pt: {
    // Welcome Modal
    welcomeTitle: "Olá! Meu nome é",
    welcomeName: "Nexi",
    welcomeSubtitle: "Seu assistente pessoal de IA",
    welcomeDescription: "Estou aqui para ajudá-lo com qualquer coisa - desde responder perguntas até analisar documentos e imagens.",
    getStarted: "Vamos Começar!",
    consentText: "Eu concordo com a",
    privacyPolicy: "Política de Privacidade",
    and: "e",
    termsOfService: "Termos de Serviço",
    consentDataText: "Eu consinto que a Nexi colete meu nome e dados de conversa para fornecer assistência personalizada.",
    enterName: "Digite seu nome...",
    continue: "Continuar",
    skip: "Pular",
    
    // Chat Interface
    messagePlaceholder: "Mensagem para Nexi...",
    askAnything: "Pergunte-me qualquer coisa!",
    upgradeTitle: "Atualizar para Premium",
    upgradeDescription: "Obtenha perguntas ilimitadas",
    oneTimePurchase: "Compra única",
    freeQuestions: "perguntas grátis restantes hoje",
    
    // Upload Menu
    camera: "Câmera",
    takePhoto: "Tirar uma foto",
    photoLibrary: "Biblioteca de Fotos",
    chooseFromGallery: "Escolher da galeria",
    document: "Documento",
    uploadDocument: "PDF, TXT, DOC, CSV",
    
    // Messages
    download: "Baixar",
    copy: "Copiar",
    copied: "Copiado!",
    helpful: "Resposta útil",
    notHelpful: "Não útil",
    
    // Sidebar
    newChat: "Novo Chat",
    conversations: "Conversas",
    noConversations: "Nenhuma conversa ainda",
    
    // Common
    loading: "Carregando...",
    error: "Algo deu errado",
    tryAgain: "Tentar novamente",
  },
  
  zh: {
    // Welcome Modal
    welcomeTitle: "你好！我的名字是",
    welcomeName: "Nexi",
    welcomeSubtitle: "您的个人AI助手",
    welcomeDescription: "我在这里帮助您处理任何事情 - 从回答问题到分析文档和图像。",
    getStarted: "开始吧！",
    consentText: "我同意",
    privacyPolicy: "隐私政策",
    and: "和",
    termsOfService: "服务条款",
    consentDataText: "我同意Nexi收集我的姓名和对话数据以提供个性化帮助。",
    enterName: "输入您的名字...",
    continue: "继续",
    skip: "跳过",
    
    // Chat Interface
    messagePlaceholder: "给Nexi发消息...",
    askAnything: "问我任何问题！",
    upgradeTitle: "升级到高级版",
    upgradeDescription: "获得无限问题",
    oneTimePurchase: "一次性购买",
    freeQuestions: "今天剩余免费问题",
    
    // Upload Menu
    camera: "相机",
    takePhoto: "拍照",
    photoLibrary: "照片库",
    chooseFromGallery: "从相册选择",
    document: "文档",
    uploadDocument: "PDF, TXT, DOC, CSV",
    
    // Messages
    download: "下载",
    copy: "复制",
    copied: "已复制！",
    helpful: "有帮助的回答",
    notHelpful: "没有帮助",
    
    // Sidebar
    newChat: "新对话",
    conversations: "对话记录",
    noConversations: "暂无对话",
    
    // Common
    loading: "加载中...",
    error: "出错了",
    tryAgain: "重试",
  },
  
  ja: {
    // Welcome Modal
    welcomeTitle: "こんにちは！私の名前は",
    welcomeName: "Nexi",
    welcomeSubtitle: "あなたの個人AIアシスタント",
    welcomeDescription: "質問への回答からドキュメントや画像の分析まで、何でもお手伝いします。",
    getStarted: "始めましょう！",
    consentText: "私は",
    privacyPolicy: "プライバシーポリシー",
    and: "と",
    termsOfService: "利用規約",
    consentDataText: "に同意し、Nexiが個人化されたサポートを提供するために私の名前と会話データを収集することに同意します。",
    enterName: "名前を入力...",
    continue: "続ける",
    skip: "スキップ",
    
    // Chat Interface
    messagePlaceholder: "Nexiにメッセージ...",
    askAnything: "何でも聞いてください！",
    upgradeTitle: "プレミアムにアップグレード",
    upgradeDescription: "無制限の質問を取得",
    oneTimePurchase: "一回限りの購入",
    freeQuestions: "本日の残り無料質問数",
    
    // Upload Menu
    camera: "カメラ",
    takePhoto: "写真を撮る",
    photoLibrary: "フォトライブラリ",
    chooseFromGallery: "ギャラリーから選択",
    document: "ドキュメント",
    uploadDocument: "PDF, TXT, DOC, CSV",
    
    // Messages
    download: "ダウンロード",
    copy: "コピー",
    copied: "コピーしました！",
    helpful: "役立つ回答",
    notHelpful: "役に立たない",
    
    // Sidebar
    newChat: "新しいチャット",
    conversations: "会話",
    noConversations: "まだ会話がありません",
    
    // Common
    loading: "読み込み中...",
    error: "エラーが発生しました",
    tryAgain: "もう一度試す",
  },
  
  ar: {
    // Welcome Modal
    welcomeTitle: "مرحباً! اسمي",
    welcomeName: "Nexi",
    welcomeSubtitle: "مساعدك الشخصي بالذكاء الاصطناعي",
    welcomeDescription: "أنا هنا لمساعدتك في أي شيء - من الإجابة على الأسئلة إلى تحليل المستندات والصور.",
    getStarted: "لنبدأ!",
    consentText: "أوافق على",
    privacyPolicy: "سياسة الخصوصية",
    and: "و",
    termsOfService: "شروط الخدمة",
    consentDataText: "أوافق على أن يجمع Nexi اسمي وبيانات المحادثة لتقديم مساعدة مخصصة.",
    enterName: "أدخل اسمك...",
    continue: "متابعة",
    skip: "تخطي",
    
    // Chat Interface
    messagePlaceholder: "رسالة إلى Nexi...",
    askAnything: "اسألني أي شيء!",
    upgradeTitle: "الترقية إلى المميز",
    upgradeDescription: "احصل على أسئلة غير محدودة",
    oneTimePurchase: "شراء لمرة واحدة",
    freeQuestions: "أسئلة مجانية متبقية اليوم",
    
    // Upload Menu
    camera: "الكاميرا",
    takePhoto: "التقاط صورة",
    photoLibrary: "مكتبة الصور",
    chooseFromGallery: "اختر من المعرض",
    document: "مستند",
    uploadDocument: "PDF, TXT, DOC, CSV",
    
    // Messages
    download: "تحميل",
    copy: "نسخ",
    copied: "تم النسخ!",
    helpful: "إجابة مفيدة",
    notHelpful: "غير مفيد",
    
    // Sidebar
    newChat: "محادثة جديدة",
    conversations: "المحادثات",
    noConversations: "لا توجد محادثات بعد",
    
    // Common
    loading: "جاري التحميل...",
    error: "حدث خطأ ما",
    tryAgain: "حاول مرة أخرى",
  },
};

// Supported languages
export const supportedLanguages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
];

// Get browser language
export const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0];
  
  // Check if we support this language
  if (translations[langCode]) {
    return langCode;
  }
  return 'en'; // Default to English
};

// Get translation
export const getTranslation = (lang, key) => {
  if (translations[lang] && translations[lang][key]) {
    return translations[lang][key];
  }
  // Fallback to English
  return translations['en'][key] || key;
};

export default translations;
